module.exports = __webpack_public_path__ + "img/angle-left.5dae3d92.svg";